import { render } from "./UserGroupUpdate.vue?vue&type=template&id=0e605117"
import script from "./UserGroupUpdate.vue?vue&type=script&lang=js"
export * from "./UserGroupUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__